/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum WithdrawalRequestStatuses {
    Draft = 'Draft',
    OnModeration = 'OnModeration',
    Approved = 'Approved',
    Rejected = 'Rejected',
    AutoClosed = 'AutoClosed',
    Processing = 'Processing'
}

